/**
 * @generated SignedSource<<4f49af6b8757926d1676c27116c2a15b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UrlMappingCreateFormContainer_Query$variables = {
  siteSlug: string;
};
export type UrlMappingCreateFormContainer_QueryVariables = UrlMappingCreateFormContainer_Query$variables;
export type UrlMappingCreateFormContainer_Query$data = {
  readonly site: {
    readonly owner: {
      readonly id: string;
      readonly nextUrlMappingPriority: number;
    };
  };
};
export type UrlMappingCreateFormContainer_QueryResponse = UrlMappingCreateFormContainer_Query$data;
export type UrlMappingCreateFormContainer_Query = {
  variables: UrlMappingCreateFormContainer_QueryVariables;
  response: UrlMappingCreateFormContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "siteSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextUrlMappingPriority",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingCreateFormContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UrlMappingCreateFormContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6cf332493e6813778b9d119d1b28e7de",
    "id": null,
    "metadata": {},
    "name": "UrlMappingCreateFormContainer_Query",
    "operationKind": "query",
    "text": "query UrlMappingCreateFormContainer_Query(\n  $siteSlug: String!\n) {\n  site(slug: $siteSlug) {\n    owner {\n      id\n      nextUrlMappingPriority\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa9858d903822492749dc006007df24e";

export default node;
